import {
  Component, OnInit, Input,
} from "@angular/core";
import { DialogService } from "../dialog/index";
import { DialogComponent } from "../dialog/dialog.component";
import { DataService } from "../../services/data.service"
import { InSalesService } from "../../services/inventory/in-sales.service";

export interface Items {
  title: string;
  data: any;
}

@Component({
  selector: 'app-zatcatransaction',
  templateUrl: './zatcatransaction.component.html',
  styleUrls: ['./zatcatransaction.component.css']
})
export class ZatcaTransactionComponent extends DialogComponent<Items, boolean>
  implements Items, OnInit {

  title: string = "";
  data: any;

  result: any = { result: false, RtnItem: {} };
  loading: boolean = false;
  ProgressText: string = "Started...";
  IntervalId: any;

  constructor(dialogService: DialogService, private ds: DataService, private ms: InSalesService) {
    super(dialogService);

  }

  ngOnInit() {
    this.sendZatcaDoc();
    this.setStatus();
  }

  sendZatcaDoc() {
    var data = {
      ZatcaDocId: 0,
      InvNo: this.data.InvNo,
      Doctype: this.data.Doctype,
      LocId: this.ds.Settings.LocationId,
      ZatcaDocPath: this.data.ZatcaDocPath,
      IsResend: this.data.IsResend,
      UserId: this.ds.Settings.UserId
    }
    this.loading = true;
    this.ms.Zatca_InvoiceGenerate(data).subscribe(res => {
      if (res.Success) {
        this.result.result = true;
        this.result.RtnItem = res.data;
        this.closeModel();

      } else {
        this.result.result = false;
        this.result.RtnItem = "";
        alert(res.error.UsrMsg);
        this.closeModel();
      }
    });
  }

  closeModel() {
    this.loading = false;
    this.stopIntervel();
    this.close();
  }

  setStatus() {
    var counter = 0
    this.IntervalId = setInterval(() => {
      counter++;
      if (counter == 1) {
        this.ProgressText = "Generating XML..."
      }
      else if (counter == 2) {
        this.ProgressText = "Signing XML..."
      }
      else if (counter == 3) {
        this.ProgressText = "Validating Signed XML..."
      }
      else if (counter == 4) {
        this.ProgressText = "Reporting Standard Invoice..."
      }
      else {
        this.ProgressText = "Validating  Standard Invoice..."
      }
    }, 1500)
  }

  stopIntervel() {
    clearInterval(this.IntervalId);
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/zatcatransaction/zatcatransaction.component.ts